import React from "react";
import star from "../../assets/star-5.svg";
import profileImg from "../../assets/pic-again.png";

const WorkSection = () => {
  const image = profileImg;

  return (
    <section className="py-10 px-5 md:px-10">
      <div className="flex flex-row justify-start items-center">
        {/* <div className="flex flex-row gap-7">
          <div className="flex flex-row gap-2">
            <button className="rounded-full" onClick={handlePreviousClick}>
              <svg
                fill="none"
                stroke-width="1.5"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="w-4 h-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                ></path>
              </svg>
            </button>
            <button className="rounded-full" onClick={handleNextClick}>
              <svg
                fill="none"
                stroke-width="1.5"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="w-4 h-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                ></path>
              </svg>
            </button>
          </div>
        </div> */}
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-10 items-center my-16 content">
        <div className="w-full md:w-1/2 flex flex-col gap-10">
                <div>
          <p className="uppercase text-[16px] font-[500] text-[#62646C]">
            Capabilities
          </p>
          <h2 className="uppercase font-medium text-2xl">How I bring products to life</h2>
        </div>
          <div>
            <div className="flex flex-row items-center gap-3">
              <img src={star} className="w-5" alt="star icon" />
              <h3>Product thinking</h3>
            </div>
            <p className="font-light leading-7 tracking-tight text-neutral-400">
            Translating real user needs and business goals into clear requirements, flows and technical decisions.
            </p>
          </div>
          <div>
            <div className="flex flex-row items-center gap-3">
              <img src={star} className="w-5" alt="star icon" />
              <h3>Frontend engineering</h3>
            </div>
            <p className="font-light leading-7 tracking-tight text-neutral-400">
            Building accessible, responsive and polished interfaces with maintainable JavaScript, TypeScript and React.
            </p>
          </div>
          <div>
            <div className="flex flex-row items-center gap-3">
              <img src={star} className="w-5" alt="star icon" />
              <h3>End-to-end delivery</h3>
            </div>
            <p className="font-light leading-7 tracking-tight text-neutral-400">
            Taking ideas beyond the interface through APIs, integrations and production-ready implementation.
            </p>
          </div>
          {/* <div>
            <div className="flex flex-row items-center gap-3">
              <img src={star} className="w-5" alt="star icon" />
              <p>Product Development, Strategy & Impact</p>
            </div>
            <p className="font-light leading-7 tracking-tight text-neutral-400">
            Designing and developing products and features that enhance user engagement, simplify workflows, and create impactful experiences that users enjoy.
            </p>
          </div> */}
        </div>
        
        <div className="w-full md:w-1/2">
          <img src={image} className="w-full" alt="profile" />
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
